import { memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './StepperBreadcrumb.module.scss';
import cx from 'classnames';

const StepperBreadcrumb = ({
  children,
  href,
  isActive,
  onClick,
  icon: Icon,
  isContentDisabled = false,
  isLink = false,
  customClasses = ''
}) => {
  const content = (
    <div className={styles['content-wrapper']}>
      <div
        data-testid="desktop-content"
        className={cx(
          styles['text'],
          'pt-2',
          {
            [styles['active']]: isActive && !customClasses,
            [styles['content-disabled']]: isContentDisabled,
            'd-none': Icon,
            'd-lg-block': Icon,
            'd-block': !Icon
          },
          customClasses
        )}
      >
        {children}
      </div>
      {Icon ? (
        <div className="pt-2 d-lg-none">
          <Icon
            className={cx(styles['icon'], {
              [styles['active']]: isActive,
              [styles['icon-content-disabled']]: isContentDisabled
            })}
          />
        </div>
      ) : null}
    </div>
  );
  if (!isActive) {
    return content;
  }
  return isLink ? (
    <Link
      to={href}
      onClick={onClick}
      data-testid="breadcrumb-link"
      className={styles['breadcrumb-anchor']}
    >
      {content}
    </Link>
  ) : (
    <a
      href={href}
      onClick={onClick}
      data-testid="breadcrumb-anchor"
      className={styles['breadcrumb-anchor']}
    >
      {content}
    </a>
  );
};

export default memo(StepperBreadcrumb);

StepperBreadcrumb.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  href: PropTypes.string,
  icon: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  isLink: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isContentDisabled: PropTypes.bool,
  customClasses: PropTypes.string
};
